import ApplicationSpec from "./ApplicationSpec";

module.exports = class FrameworkSpec extends ApplicationSpec {};



// WEBPACK FOOTER //
// ./plugins/services/src/js/structs/FrameworkSpec.js